import React from "react";
import {
    Box,
    Button,
    Heading,
    Layer,
    Page,
    Text,
    Tip,
    Select,
    TextArea,
    Paragraph,
} from "grommet";
import { useLocation } from "react-router-dom";
import useBook from "../../hooks/useBook";
import useToc from "../../hooks/useToc";
import useTocRecord from "../../hooks/useTocRecord";
import useTableau from "../../hooks/useTableau";
import useTableauRecord from "../../hooks/useTableauRecord";
import usePsnorder from "../../hooks/usePsnorder";
import usePerson from "../../hooks/usePerson";

import PageMainCanvas from "./PageMainCanvas";
import { MdPerson } from "react-icons/md";

import { useRecoilState } from "recoil";
import {
    libraryBooks,
    libraryTocs,
    libraryTableaux,
    libraryTocRecords,
    libraryTableauRecords,
    personDataLibrary,
} from "../../recoils/library";
import { table } from "console";
import { Add, CaretDown, Close, ShareRounded, StatusInfo } from "grommet-icons";
import LoadingSign from "../../shared_comp/LoadingSign";
import SearchPersonModal from "../../modals/SearchPersonModal";
import getColors from "../../functions/getColors";

interface PersonDataFormat {
    person_id: number;
    person_info: any;
    person_check: boolean;
    books: any[];
    tocs: any[];
    tableaux: any[];
    toc_records: any[];
    tableau_records: any[];
    psnorders: any[];
}
interface DataUnitFormat {
    unit_id: number;
    person_id: number;
    data_type: string;
    data_year: number;
    data_date: string;
    book_id: number;
    book_author?: string;
    book_category?: string;
    book_type?: string;
    book_title: string;
    book_numeration?: string;
    book_publisher?: string;
    toc_id?: number;
    toc_title?: string;
    tableau_id?: number;
    tableau_title?: string;
    toc_record_id?: number;
    toc_record_text?: string;
    tableau_record_id?: number;
    tableau_record_text?: string;
    psnorder_id?: number;
    psnorder_text?: string;
    page_info?: string;
    related_school_id?: number | null;
    related_school_name?: string | null;
}

const PagePersonMain = () => {
    let location = useLocation();
    const id_list = location.hash.split("#").pop() || "";
    const [personIds, setPersonIds] = React.useState<number[]>([]);
    const [personInfos, setPersonInfos] = React.useState<any>([]);

    const [selectedPersonIds, setSelectedPersonIds] = React.useState<any>([]);

    let ids = id_list.split("&");

    React.useEffect(() => {
        setReadyPersonData(false);
        let ids_n = ids.map((id) => parseInt(id));
        setPersonIds(ids_n);

        //console.log("PagePersonMain", ids_n);

        const receivePersonInfo = async () => {
            const res = await usePerson.getPersonsByIds(ids);
            //console.log("PagePersonMain", res);
            setPersonInfos(res.persons);
            setSelectedPersonIds(
                res.persons.map((p: any) => p.person.person_id)
            );
        };
        receivePersonInfo();
        setReadyPersonData(false);
        setReadyShowList(false);
        setPersonDataList([]);
        setAddMorePerson(false);
        setShowDataList([]);
        setFilteredDataList([]);
        setModificationMode(false);
        setNewShowDataList([]);
        setSendModification(false);
    }, [location]);
    const PersonListBox = () => {
        const APersonButton = (props: any) => {
            let name = props.name;
            let name_ko = props.name_ko;
            let id = props.id;
            let pindex = personInfos.findIndex(
                (p: any) => p.person.person_id === id
            );
            return (
                <Tip
                    plain
                    content={
                        name_ko !== name && (
                            <Box
                                background="rgba(255,255,255, 0.9)"
                                align="center"
                                justify="center"
                            >
                                <Text size="10px">{name_ko}</Text>
                            </Box>
                        )
                    }
                >
                    <Button
                        margin={{ horizontal: "5px" }}
                        plain
                        label={
                            <Box
                                margin={{ vertical: "5px" }}
                                hoverIndicator
                                pad="10px"
                                round="5px"
                                direction="row"
                                align="center"
                                justify="center"
                                border={
                                    selectedPersonIds.includes(id)
                                        ? { color: "black" }
                                        : { color: "grey" }
                                }
                                background={
                                    selectedPersonIds.includes(id)
                                        ? "rgba(255,255,255,0.9)"
                                        : "rgba(255,255,255,0.1)"
                                }
                            >
                                <Text size="12px" margin={{ right: "2px" }}>
                                    {pindex + 1}
                                </Text>
                                <Text size="16px">{name}</Text>
                            </Box>
                        }
                        onClick={() => {
                            if (selectedPersonIds.includes(id)) {
                                if (selectedPersonIds.length === 1) {
                                    setSelectedPersonIds(personIds);
                                } else {
                                    setSelectedPersonIds(
                                        selectedPersonIds.filter(
                                            (p: any) => p !== id
                                        )
                                    );
                                }
                            } else {
                                setSelectedPersonIds([
                                    ...selectedPersonIds,
                                    id,
                                ]);
                            }
                        }}
                    />
                </Tip>
            );
        };
        return (
            <Box
                pad="10px"
                round="5px"
                align="center"
                style={{ minHeight: "70px" }}
                flex={false}
            >
                <Text>
                    {personInfos.map((p: any) => (
                        <APersonButton
                            key={p.person.person_id}
                            name={p.person.primaryname}
                            name_ko={p.person.primaryname_ko}
                            id={p.person.person_id}
                        />
                    ))}
                </Text>
            </Box>
        );
    };
    const [personDataList, setPersonDataList] = React.useState<any>([]);
    const [readyPersonData, setReadyPersonData] = React.useState<any>(false);
    const [libraryBooksData, setLibraryBooksData] =
        useRecoilState(libraryBooks);
    const [libraryTocsData, setLibraryTocsData] = useRecoilState(libraryTocs);
    const [libraryTableauxData, setLibraryTableauxData] =
        useRecoilState(libraryTableaux);

    const requestPersonData = async (person_info: any) => {
        let personData = personDataList.filter(
            (p: any) => p.person_id === person_info.person.person_id
        )[0];
        //console.log("requestPersonData info", person_info, personData);

        const getPersonData = async (id: number) => {
            let res_psnorders = await usePsnorder.getPsnordersBySPR({
                person_ids: [id],
            });
            let res_books = await useBook.getBooksBySP({ person_id: id });
            let res_tocs = await useToc.getTocsBySPR({ person_ids: [id] });
            let res_tableaux = await useTableau.getTableauxBySPR({
                person_ids: [id],
            });
            let res_toc_records = await useTocRecord.getTocrecordsBySPR({
                person_ids: [id],
            });
            let res_tableau_records =
                await useTableauRecord.getTableaurecordsBySPR({
                    person_ids: [id],
                });

            // //console.log("getPersonData", id, res_psnorders, res_books, res_tocs, res_tableaux, res_toc_records, res_tableau_records)
            return {
                psnorders: res_psnorders.psnorders,
                books: res_books.books,
                tocs: res_tocs.tocs,
                tableaux: res_tableaux.tableaux,
                toc_records: res_toc_records.tocrecords,
                tableau_records: res_tableau_records.tableaurecords,
            };
        };
        let p_data = await getPersonData(person_info.person.person_id);
        personData.psnorders = p_data.psnorders;
        personData.books = p_data.books;
        personData.tocs = p_data.tocs;
        personData.tableaux = p_data.tableaux;
        personData.toc_records = p_data.toc_records;
        personData.tableau_records = p_data.tableau_records;
        personData.person_check = true;

        let check_list = personDataList.filter(
            (p: any) => p.person_id !== person_info.person.person_id
        );
        // remove duplicate person data list
        let new_list: any = [];
        let new_list_id: any = [];
        check_list.forEach((p: any) => {
            if (!new_list_id.includes(p.person_id)) {
                new_list_id.push(p.person_id);
                new_list.push(p);
            }
        });
        new_list.push(personData);
        setPersonDataList(new_list);
        //console.log( "requestPersonData result", person_info, personData, new_list);
    };

    React.useEffect(() => {
        if (personInfos.length > 0) {
            //console.log("personInfos", personInfos, personIds);
            setReadyShowList(false);
            personInfos.forEach((p: any) => {
                //console.log("personInfos", p.person.person_id);
                let personData: PersonDataFormat = {
                    person_id: p.person.person_id,
                    person_info: p,
                    person_check: false,
                    books: [],
                    tocs: [],
                    tableaux: [],
                    toc_records: [],
                    tableau_records: [],
                    psnorders: [],
                };
                personDataList.push(personData);
                setPersonDataList(personDataList);
                requestPersonData(p);
            });
        }
    }, [personInfos]);

    const [showDataList, setShowDataList] = React.useState<any>([]);
    const [filteredDataList, setFilteredDataList] = React.useState<any>([]);

    React.useEffect(() => {
        if (
            personDataList.length > 0 &&
            personDataList.length === personInfos.length
        ) {
            // check in personDataList all person_check is true
            let check = true;
            personDataList.forEach((p: any) => {
                check = check && p.person_check;
            });
            if (check) {
                setReadyPersonData(true);
                //console.log("personDataList", personDataList);
            }
        }
    }, [personInfos, personDataList]);

    const getABookById = async (book_id: number) => {
        let res = await useBook.getBookById(book_id.toString());
        let res_tocs = await useToc.getTocsByBookId(book_id.toString());
        return { book: res.book, toc: res_tocs.tocs };
    };

    const [nUnit, setNUnit] = React.useState<number>(0);

    const convertPsnorder = (props: any) => {
        let psnorders = props.psnorders;
        const PushData = (props: any) => {
            // make n_unit unique with timestamp
            // hour, minute, second
            let hour = new Date().getHours();
            let minute = new Date().getMinutes();
            let second = new Date().getSeconds();
            let milisecond = new Date().getMilliseconds();
            let n_unit =
                nUnit +
                1 +
                100 *
                    parseInt(
                        hour + "" + minute + "" + second + "" + milisecond
                    );
                    // add random number to make n_unit unique
                    // 1000 ~ 9999
            n_unit += Math.floor(Math.random() * 9000) + 1000;
            setNUnit(n_unit);
            let p = props.p;
            let po_type = props.po_type;
            let book_title = props.book_title;
            let toc_title = props.toc_title;
            let record_text = props.record_text;
            let data: DataUnitFormat = {
                unit_id: n_unit,
                person_id: props.person_id,
                data_type: "psnorder",
                data_year: p.po_year,
                data_date: p.po_date,
                book_id: p.book_id,
                book_type: p.po_type,
                book_category: po_type,
                book_title: book_title,
                book_numeration: props.book_numeration,
                toc_id: p.toc_id,
                toc_title: toc_title,
                psnorder_id: p.psnorder_id,
                psnorder_text: record_text,
                page_info: p.page,
            };
            let data_all = showDataList;
            let list_psnorders = data_all.filter(
                (d: any) => d.data_type === "psnorder"
            );
            let data_list = list_psnorders.filter(
                (d: any) => d.psnorder_id === data.psnorder_id
            );
            if (data_list.length === 0) {
                data_all.push(data);
                // sort data_all by data_year and data_date
                data_all.sort((a: any, b: any) => {
                    if (a.data_year === b.data_year) {
                        if (a.data_date === b.data_date) {
                            return 0;
                        } else {
                            return a.data_date < b.data_date ? -1 : 1;
                        }
                    } else {
                        return a.data_year < b.data_year ? -1 : 1;
                    }
                });
                setShowDataList(data_all);
                //console.log("Add data from library book", data, data_list);
            } else {
                //console.log( "ShowDataList already has psnorder",  data_all, data_list,data);
            }
        };
        psnorders.forEach((p: any) => {
            let po_type = "경기도보";
            // 경기도보 한자: 京畿道報
            let book_title = null;
            let toc_title = p.po_date;
            let record_text = p.record_text.replace(";", " ");

            if (p.po_type === "redbook") {
                po_type = "직원록";
                toc_title = p.status_text;
                let r_div = p.record_text.split("#");
                if (r_div.length === 8) {
                    record_text = r_div[3] + ", " + r_div[7];
                    if (r_div[5].length > 0) {
                        record_text += ", 등급:" + r_div[5];
                    }
                    if (r_div[6].length > 0) {
                        record_text += ", 공훈:" + r_div[6];
                    }
                    if (r_div[4].length > 0) {
                        record_text += ", " + r_div[4];
                    }
                    // 3 직위, 4 비고, 5 관등, 6 공훈, 7 이름
                    // find data in libraryBooksData by book_id, with findIndex
                    let book_index = libraryBooksData.findIndex(
                        (b: any) => b.book_id === p.book_id
                    );
                    if (book_index >= 0) {
                        let a_book = libraryBooksData[book_index];
                        PushData({
                            book_title: a_book.book_title,
                            book_numeration: a_book.numeration,
                            toc_title: toc_title,
                            record_text: record_text,
                            person_id: props.person_id,
                            p: p,
                            po_type: po_type,
                        });
                    } else {
                        // call api getBookById and add to libraryBooksData
                        getABookById(p.book_id).then((b: any) => {
                            setLibraryBooksData([...libraryBooksData, b.book]);
                            // setLibraryTocsData([...libraryTocsData, b.tocs])
                            let a_book = b.book;
                            // console.log("book_title", book_title)
                            PushData({
                                book_title: a_book.book_title,
                                book_numeration: a_book.numeration,
                                toc_title: toc_title,
                                record_text: record_text,
                                person_id: props.person_id,
                                p: p,
                                po_type: po_type,
                            });
                        });
                    }
                }
            } else {
                let book_index = libraryBooksData.findIndex(
                    (b: any) => b.book_id === p.book_id
                );
                let a_book: any = {};
                if (book_index >= 0) {
                    a_book = libraryBooksData[book_index];
                    book_title = a_book.book_title;
                    if (a_book.numeration && a_book.numeration.length > 0) {
                        book_title += ", " + a_book.numeration;
                    }
                    PushData({
                        book_title: a_book.book_title,
                        book_numeration: a_book.numeration,
                        toc_title: toc_title,
                        record_text: record_text,
                        person_id: props.person_id,
                        p: p,
                        po_type: po_type,
                    });
                    // let data_all = showDataList
                    // let list_psnorders = data_all.filter((d: any) => d.data_type === "psnorder")
                    // let data_list = list_psnorders.filter((d: any) => d.psnorder_id === p.psnorder_id)
                    // if (data_list.length === 0) {
                    //     data_all.push(data)
                    //     data_all.sort((a: any, b: any) => {
                    //         if (a.data_year === b.data_year) {
                    //             if (a.data_date === b.data_date) {
                    //                 return 0
                    //             } else {
                    //                 return a.data_date < b.data_date ? -1 : 1
                    //             }
                    //         } else {
                    //             return a.data_year < b.data_year ? -1 : 1
                    //         }
                    //     })
                    //     setShowDataList(data_all)
                    //     console.log("Add data from library book", data, data_list);
                    // } else {
                    //     console.log("ShowDataList already has psnorder", data_all, data_list, data)
                    // }
                } else {
                    getABookById(p.book_id).then((b: any) => {
                        setLibraryBooksData([...libraryBooksData, b.book]);
                        // setLibraryTocsData([...libraryTocsData, b.tocs])
                        a_book = b.book;
                        PushData({
                            book_title: a_book.book_title,
                            book_numeration: a_book.numeration,
                            toc_title: toc_title,
                            record_text: record_text,
                            person_id: props.person_id,
                            p: p,
                            po_type: po_type,
                        });
                        // let data_all = showDataList
                        // let list_psnorders = data_all.filter((d: any) => d.data_type === "psnorder")
                        // let data_list = list_psnorders.filter((d: any) => d.psnorder_id === p.psnorder_id)
                        // if (data_list.length === 0) {
                        //     data_all.push(data)
                        //     data_all.sort((a: any, b: any) => {
                        //         if (a.data_year === b.data_year) {
                        //             if (a.data_date === b.data_date) {
                        //                 return 0
                        //             } else {
                        //                 return a.data_date < b.data_date ? -1 : 1
                        //             }
                        //         } else {
                        //             return a.data_year < b.data_year ? -1 : 1
                        //         }
                        //     })
                        //     setShowDataList(data_all)
                        //     console.log("Add data from new book", data, data_list);
                        // } else {
                        //     console.log("[dup] ShowDataList already has psnorder", data_all, data_list, data)
                        // }
                    });
                }
            }
        });
    };

    const convertBook = (props: any) => {
        let books = props.books;
        books.forEach((b: any) => {
            let book_title = b.book_title;
            if (b.numeration && b.numeration.length > 0) {
                book_title += " " + b.numeration;
            }
            // make n_unit unique with timestamp
            // hour, minute, second
            let hour = new Date().getHours();
            let minute = new Date().getMinutes();
            let second = new Date().getSeconds();
            let milisecond = new Date().getMilliseconds();
            let n_unit =
                nUnit +
                1 +
                100 *
                    parseInt(
                        hour + "" + minute + "" + second + "" + milisecond
                    );
            n_unit += Math.floor(Math.random() * 9000) + 1000;
            setNUnit(n_unit);

            let data: DataUnitFormat = {
                unit_id: n_unit,
                person_id: props.person_id,
                data_type: "book",
                data_year: b.publish_year,
                data_date: b.publish_date,
                book_id: b.book_id,
                book_type: b.book_type,
                book_category: b.book_category,
                book_title: book_title,
                book_author: b.authors,
                book_publisher: b.publisher,
            };
            let data_all = showDataList;
            let list_books = data_all.filter(
                (d: any) => d.data_type === "book"
            );
            let data_list = list_books.filter(
                (d: any) => d.book_id === data.book_id
            );
            if (data_list.length === 0) {
                data_all.push(data);
                data_all.sort((a: any, b: any) => {
                    if (a.data_year === b.data_year) {
                        if (a.data_date === b.data_date) {
                            return 0;
                        } else {
                            return a.data_date < b.data_date ? -1 : 1;
                        }
                    } else {
                        return a.data_year < b.data_year ? -1 : 1;
                    }
                });
                setShowDataList(data_all);
                //console.log("Add data from library book", data, data_list);
            } else {
                //console.log("ShowDataList already has book", data_all, data_list, data );
            }
        });
    };

    const convertToc = (props: any) => {
        let tocs = props.tocs;
        const PushData = (props: any) => {
            let a_book = props.a_book;
            let t = props.t;
            let book_title = a_book.book_title;
            if (a_book.numeration && a_book.numeration.length > 0) {
                book_title += " " + a_book.numeration;
            }
            // make n_unit unique with timestamp
            // hour, minute, second
            let hour = new Date().getHours();
            let minute = new Date().getMinutes();
            let second = new Date().getSeconds();
            let milisecond = new Date().getMilliseconds();
            let n_unit =
                nUnit +
                1 +
                100 *
                    parseInt(
                        hour + "" + minute + "" + second + "" + milisecond
                    );
            n_unit += Math.floor(Math.random() * 9000) + 1000;
            setNUnit(n_unit);
            let data: DataUnitFormat = {
                unit_id: n_unit,
                person_id: props.person_id,
                data_type: "toc",
                data_year: a_book.publish_year,
                data_date: a_book.publish_date,
                book_id: t.book_id,
                book_type: a_book.book_type,
                book_category: a_book.book_category,
                book_title: book_title,
                book_numeration: a_book.numeration,
                book_author: a_book.authors,
                book_publisher: a_book.publisher,
                toc_id: t.toc_id,
                toc_title: t.toc_title,
                page_info: t.page_start,
            };
            return data;
        };
        tocs.forEach((t: any) => {
            let book_index = libraryBooksData.findIndex(
                (b: any) => b.book_id === t.book_id
            );
            let a_book: any = {};
            if (book_index >= 0) {
                a_book = libraryBooksData[book_index];
                const data = PushData({
                    a_book: a_book,
                    t: t,
                    person_id: props.person_id,
                });
                let data_all = showDataList;
                let list_tocs = data_all.filter(
                    (d: any) => d.data_type === "toc"
                );
                let data_list = list_tocs.filter(
                    (d: any) => d.toc_id === t.toc_id
                );
                if (data_list.length === 0) {
                    data_all.push(data);
                    data_all.sort((a: any, b: any) => {
                        if (a.data_year === b.data_year) {
                            if (a.data_date === b.data_date) {
                                return 0;
                            } else {
                                return a.data_date < b.data_date ? -1 : 1;
                            }
                        } else {
                            return a.data_year < b.data_year ? -1 : 1;
                        }
                    });
                    setShowDataList(data_all);
                    // console.log(
                    //     "Add data from library book",
                    //     data,
                    //     a_book,
                    //     data_list
                    // );
                } else {
                    // console.log(
                    //     "ShowDataList already has toc",
                    //     data_all,
                    //     data_list,
                    //     data
                    // );
                }
            } else {
                getABookById(t.book_id).then((b: any) => {
                    setLibraryBooksData([...libraryBooksData, b.book]);
                    a_book = b.book;
                    const data = PushData({
                        a_book: a_book,
                        t: t,
                        person_id: props.person_id,
                    });
                    let data_all = showDataList;
                    let list_tocs = data_all.filter(
                        (d: any) => d.data_type === "toc"
                    );
                    let data_list = list_tocs.filter(
                        (d: any) => d.toc_id === t.toc_id
                    );
                    if (data_list.length === 0) {
                        data_all.push(data);
                        data_all.sort((a: any, b: any) => {
                            if (a.data_year === b.data_year) {
                                if (a.data_date === b.data_date) {
                                    return 0;
                                } else {
                                    return a.data_date < b.data_date ? -1 : 1;
                                }
                            } else {
                                return a.data_year < b.data_year ? -1 : 1;
                            }
                        });
                        setShowDataList(data_all);
                        // console.log(
                        //     "Add data from new book",
                        //     data,
                        //     a_book,
                        //     data_list
                        // );
                    } else {
                        // console.log(
                        //     "[dup] ShowDataList already has toc",
                        //     data_all,
                        //     data_list,
                        //     data
                        // );
                    }
                });
            }
        });
    };

    const convertTableau = (props: any) => {
        // preparing
    };

    const convertTocRecord = (props: any) => {
        let toc_records = props.toc_records;
        const pushData = (props: any) => {
            let a_book = props.a_book;
            let t = props.t;
            let school_id = null;
            let school_name = null;
            let record_type = t.record_type;
            let record_text = t.record_text;
            if (record_type === "list") {
                // remove first two letters and last two letters of record_text
                record_text = record_text.slice(2, -2);
                // remove ' and "
                record_text = record_text.replaceAll("'", "");
                record_text = record_text.replaceAll('"', "");
                // console.log("before", record_text)

                // remove "이름:[,  , ]"
                let record_part1 = record_text.split(", 이름:")[0];
                let record_part2 = record_text.split(", 이름:")[1];
                let record_part3 = record_part2.split("]")[1];
                record_text = record_part1 + record_part3;
                // console.log("after",record_text)

                let record_div = record_text.split(",");
                // console.log("div", record_div)

                let dont_show_prop = [
                    "number",
                    "book_id",
                    "book_category",
                    "numeration",
                    "pub_date",
                    "publisher",
                    "book_title",
                    "toc_title",
                    "toc_id",
                    "person_id",
                    "이름",
                    "발행",
                    "record_page",
                    "school_id",
                    "school_name",
                ];
                let record_text_list: any = [];

                record_div.forEach((r: any) => {
                    let key = r.split(":")[0];
                    key = key.replaceAll("'", "");
                    // remove white space
                    key = key.replaceAll(" ", "");
                    let value = "";
                    if (r.split(":").length > 1) {
                        value = r.split(":")[1];
                        value = value.replaceAll("'", "");
                    }
                    if (value[0] === " ") {
                        value = value.slice(1);
                    }
                    // console.log("r", r, key, value)
                    if (!dont_show_prop.includes(key)) {
                        record_text_list.push(key + ":" + value);
                    } else if (key === "school_id") {
                        school_id = parseInt(value);
                        // console.log("School id", school_id);
                    } else if (key === "school_name") {
                        school_name = value;
                        // console.log("School name", school_name);
                    }
                });
                // console.log("record_text_list", record_text_list)
                record_text = record_text_list.join(", ");
                // console.log("join", record_text);
            }
            // make n_unit unique with timestamp
            // hour, minute, second
            let hour = new Date().getHours();
            let minute = new Date().getMinutes();
            let second = new Date().getSeconds();
            let milisecond = new Date().getMilliseconds();
            let n_unit =
                nUnit +
                1 +
                100 *
                    parseInt(
                        hour + "" + minute + "" + second + "" + milisecond
                    );
            n_unit += Math.floor(Math.random() * 9000) + 1000;
            setNUnit(n_unit);
            let data: DataUnitFormat = {
                unit_id: n_unit,
                person_id: props.person_id,
                data_type: "toc_record",
                data_year: a_book.publish_year,
                data_date: a_book.publish_date,
                book_id: t.book_id,
                book_type: a_book.book_type,
                book_category: a_book.book_category,
                book_title: a_book.book_title,
                book_numeration: a_book.numeration,
                book_author: a_book.authors,
                book_publisher: a_book.publisher,
                toc_id: t.toc_id,
                toc_title: t.toc_title,
                toc_record_id: t.tocrecord_id,
                toc_record_text: record_text,
                page_info: t.page_start,
                related_school_id: school_id,
                related_school_name: school_name,
            };
            return data;
        };
        toc_records.forEach((t: any) => {
            let book_index = libraryBooksData.findIndex(
                (b: any) => b.book_id === t.book_id
            );
            let a_book: any = {};
            if (book_index >= 0) {
                a_book = libraryBooksData[book_index];
                const data = pushData({
                    a_book: a_book,
                    t: t,
                    person_id: props.person_id,
                });
                let data_all = showDataList;
                let list_tocrecords = data_all.filter(
                    (d: any) => d.data_type === "toc_record"
                );
                let data_list = list_tocrecords.filter(
                    (d: any) => d.toc_record_id === data.toc_record_id
                );
                if (data_list.length === 0) {
                    data_all.push(data);
                    data_all.sort((a: any, b: any) => {
                        if (a.data_year === b.data_year) {
                            if (a.data_date === b.data_date) {
                                return 0;
                            } else {
                                return a.data_date < b.data_date ? -1 : 1;
                            }
                        } else {
                            return a.data_year < b.data_year ? -1 : 1;
                        }
                    });
                    setShowDataList(data_all);
                    // console.log(
                    //     "Add data from library book",
                    //     data,
                    //     a_book,
                    //     data_list
                    // );
                } else {
                    // console.log(
                    //     "ShowDataList already has tocrecord",
                    //     data_all,
                    //     data_list,
                    //     data
                    // );
                }
            } else {
                getABookById(t.book_id).then((b: any) => {
                    setLibraryBooksData([...libraryBooksData, b.book]);

                    a_book = b.book;
                    // console.log("get a book by id", a_book);
                    const data = pushData({
                        a_book: a_book,
                        t: t,
                        person_id: props.person_id,
                    });
                    let data_all = showDataList;
                    let list_tocrecords = data_all.filter(
                        (d: any) => d.data_type === "toc_record"
                    );
                    let data_list = list_tocrecords.filter(
                        (d: any) => d.toc_record_id === data.toc_record_id
                    );
                    if (data_list.length === 0) {
                        data_all.push(data);
                        data_all.sort((a: any, b: any) => {
                            if (a.data_year === b.data_year) {
                                if (a.data_date === b.data_date) {
                                    return 0;
                                } else {
                                    return a.data_date < b.data_date ? -1 : 1;
                                }
                            } else {
                                return a.data_year < b.data_year ? -1 : 1;
                            }
                        });
                        setShowDataList(data_all);
                        // console.log(
                        //     "Add data from new book",
                        //     data,
                        //     a_book,
                        //     data_list
                        // );
                    // } else {
                    //     console.log(
                    //         "[dup] ShowDataList already has tocrecord",
                    //         data_all,
                    //         data_list,
                    //         data
                    //     );
                    }
                });
            }
        });
    };
    const convertTableauRecord = (props: any) => {
        // preparing
    };

    const makeAPersonDataList = (props: any) => {
        let p_data = props;
        if (p_data.psnorders.length > 0) {
            convertPsnorder({
                psnorders: p_data.psnorders,
                person_id: p_data.person_id,
                numeration: p_data.numeration,
            });
        }
        if (p_data.books.length > 0) {
            convertBook({ books: p_data.books, person_id: p_data.person_id });
        }
        if (p_data.tocs.length > 0) {
            convertToc({ tocs: p_data.tocs, person_id: p_data.person_id });
        }
        if (p_data.toc_records.length > 0) {
            convertTocRecord({
                toc_records: p_data.toc_records,
                person_id: p_data.person_id,
            });
        }
    };
    const [readyShowList, setReadyShowList] = React.useState<any>(false);

    React.useEffect(() => {
        if (readyPersonData) {
            let count = 0;
            personDataList.forEach((p: any) => {
                if (personIds.includes(p.person_id)) {
                    count += 1;
                    makeAPersonDataList(p);
                    if (count === personIds.length) {
                        setReadyShowList(true);
                    } else {
                        setReadyShowList(false);
                    }
                }
            });
        } else {
            setReadyShowList(false);
        }
    }, [readyPersonData]);

    React.useEffect(() => {
        if (readyShowList) {
            //console.log("showDataList", showDataList);

            // sort showDataList by data_year and data_date
            showDataList.sort((a: any, b: any) => {
                if (a.data_year === b.data_year) {
                    if (a.data_date === b.data_date) {
                        return 0;
                    } else {
                        return a.data_date < b.data_date ? -1 : 1;
                    }
                } else {
                    return a.data_year < b.data_year ? -1 : 1;
                }
            });
            let new_show_list = showDataList.filter((d: any) =>
                selectedPersonIds.includes(d.person_id)
            );
            setFilteredDataList(new_show_list);
        } else {
            setFilteredDataList(showDataList);
        }
    }, [showDataList, readyShowList, personDataList, selectedPersonIds]);

    // create a list of alphabet from A to Z
    const alphabetList = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
    const [colorPalette, setColorPalette] = React.useState<any>([]);

    const [modificationMode, setModificationMode] = React.useState<any>(false);
    const [newShowDataList, setNewShowDataList] = React.useState<any>([]);

    const startModification = () => {
        setModificationMode(true);
        //console.log("startModification", showDataList);

        // make copy of showDataList with alphabet numbering
        showDataList.forEach((d: any) => {
            let alphabet = alphabetList[personIds.indexOf(d.person_id)];
            d.alphabet = alphabet;
        });
        //console.log("startModification new list", showDataList);
        setNewShowDataList(showDataList);
        // make alphabet list
        let new_color_palette = getColors([]);
        setColorPalette(new_color_palette);
    };

    const [sendModification, setSendModification] = React.useState<any>(false);

    const AData = (props: any) => {
        let data = props.data;
        let pindex = props.pindex + 1;
        let toc_title = data.toc_title;
        if (toc_title) {
            toc_title = toc_title.replaceAll("ㅁ", " ");
            toc_title = toc_title.replaceAll("/", " / ");
            toc_title = toc_title.replaceAll("  ", " ");
        }
        let tocrecord_text_list = null;
        if (data.toc_record_text) {
            data.toc_record_text = data.toc_record_text.replaceAll(
                "pname:",
                ""
            );
            tocrecord_text_list = data.toc_record_text.split(",");
        }

        const paList = alphabetList;
        const ChangePersonSetting = () => {
            let currentPA = data.alphabet;
            const [selectPA, setSelectPA] = React.useState<any>(currentPA);
            const paRender = (pa: any) => (
                <Box
                    pad={{ horizontal: "11px", vertical: "5px" }}
                    alignSelf="center"
                    background="white"
                    width="full"
                >
                    <Text size="15px" color="black">
                        {pa}
                    </Text>
                </Box>
            );
            const changePA = (props: any) => {
                let new_pa = props.pa;
                //console.log("changePA", data.alphabet, new_pa);
                // change data.alphabet
                data.alphabet = new_pa;

                // change newShowDataList
                let new_list = newShowDataList;
                let index = new_list.findIndex(
                    (d: any) => d.unit_id === data.unit_id
                );
                new_list[index] = data;
                setNewShowDataList(new_list);
                setSelectPA(new_pa);
            };
            return (
                <Box
                    background={colorPalette[paList.indexOf(currentPA)]}
                    height="full"
                    align="center"
                    justify="center"
                    style={{ minWidth: "80px", maxWidth: "80px" }}
                >
                    <Select
                        dropHeight="small"
                        plain
                        icon={<CaretDown size="small" />}
                        valueLabel={
                            <Box
                                width="30px"
                                overflow="hidden"
                                align="center"
                                border={{
                                    color: "grey",
                                    size: "0.2px",
                                }}
                                background="white"
                            >
                                <Text size="15px" color="black">
                                    {currentPA}
                                </Text>
                            </Box>
                        }
                        options={paList}
                        onChange={(e: any) => {
                            //console.log(data.alphabet, e.option);
                            changePA({ pa: e.option });
                        }}
                    >
                        {paRender}
                    </Select>
                </Box>
            );
        };
        const IndexBox = (props: any) => {
            let pindex = props.pindex;
            return (
                <Box
                    direction="column"
                    align="center"
                    justify="center"
                    height="full"
                    style={{ minWidth: "25px", maxWidth: "25px" }}
                >
                    <Box
                        width="25px"
                        height="25px"
                        round="2px"
                        border
                        align="center"
                        justify="center"
                    >
                        <Text size="15px">{pindex}</Text>
                    </Box>
                </Box>
            );
        };
        const YearBox = (props: any) => {
            let year = props.year;
            return (
                <Box
                    direction="column"
                    align="center"
                    justify="center"
                    height="full"
                    style={{ minWidth: "50px", maxWidth: "50px" }}
                >
                    <Box
                        height="25px"
                        round="2px"
                        align="center"
                        justify="center"
                    >
                        <Text size="15px">{year}</Text>
                    </Box>
                </Box>
            );
        };
        const BookInfo = (props: any) => {
            let book_title = props.book_title;
            let book_category = props.book_category;
            let book_author = props.book_author;
            let book_publisher = props.book_publisher;
            let book_numeration = props.book_numeration;
            let data_date = props.data_date;

            return (
                <Text size="15px">
                    <Text size="12px" margin={{ right: "10px" }}>
                        자료:{" "}
                    </Text>
                    <Text size="12px" margin={{ right: "10px" }}>
                        [{book_category}]
                    </Text>
                    <Text size="12px" margin={{ right: "10px" }}>
                        {book_author}
                    </Text>
                    <Text size="15px" margin={{ right: "10px" }}>
                        {book_title}
                    </Text>
                    <Text size="12px" margin={{ right: "10px" }}>
                        {book_numeration}
                    </Text>
                    <Text size="12px" margin={{ right: "10px" }}>
                        {book_publisher}
                    </Text>
                    <Text size="12px" margin={{ right: "10px" }}>
                        {data_date}
                    </Text>
                </Text>
            );
        };
        const TocInfo = (props: any) => {
            let toc_title = props.toc_title;
            return (
                <Box
                    direction="row"
                    align="center"
                    justify="start"
                    margin={{ bottom: "5px" }}
                >
                    <Text size="15px">
                        <Text size="12px" margin={{ right: "10px" }}>
                            목차:{" "}
                        </Text>
                        <Text size="15px" margin={{ right: "10px" }}>
                            {toc_title}
                        </Text>
                    </Text>
                </Box>
            );
        };
        const TocRecordInfo = (props: any) => {
            let tocrecord_text = props.tocrecord_text;
            return(
                <Box
                    direction="row"
                    align="center"
                    justify="start"
                    margin={{ bottom: "5px" }}
                >
                    <Text size="15px">
                        <Text
                            size="12px"
                            margin={{ right: "10px" }}
                        >
                            내용:{" "}
                        </Text>
                        <Text
                            size="15px"
                            margin={{ right: "15px" }}
                        >
                            {tocrecord_text.map(
                                (t: any) => {
                                    let t_div = t.split(":");
                                    if (t_div.length === 2) {
                                        return (
                                            <Text
                                                size="15px"
                                                margin={{
                                                    right: "15px",
                                                }}
                                                key={t_div[0]}
                                            >
                                                <Text size="10px">
                                                    {t_div[0]}:
                                                </Text>
                                                <Text size="15px">
                                                    {t_div[1]}
                                                </Text>
                                            </Text>
                                        );
                                    } else {
                                        return (
                                            <Text
                                                size="15px"
                                                margin={{
                                                    right: "15px",
                                                }}
                                                key={t}
                                            >
                                                {t}
                                            </Text>
                                        );
                                    }
                                }
                            )}
                        </Text>
                    </Text>
                </Box>
            )
        }
        const PageInfo = (props: any) => {
            let page = props.page;
            return (
                <Box
                    direction="row"
                    align="center"
                    justify="start"
                    margin={{ bottom: "5px" }}
                >
                    <Text size="15px">
                        <Text size="12px" margin={{ right: "10px" }}>
                            페이지:{" "}
                        </Text>
                        <Text size="12px" margin={{ right: "10px" }}>
                            {page.replace(".0", "")}
                        </Text>
                    </Text>
                </Box>
            );
        }

        const PsnorderText = (props: any) => {
            let t = props.t;
            // console.log(t);
            let t_div = t.split(":");
            if (t_div.length === 2) {
                return (
                    <Text size="15px" margin={{ right: "15px" }} key={t}>
                        <Text size="10px">{t_div[0]}:</Text>
                        <Text size="15px">{t_div[1]}</Text>
                    </Text>
                );
            } else {
                return (
                    <Text size="15px" margin={{ right: "15px" }} key={t}>{t}</Text>
                );
            }
        };
        return (
            <>
                {selectedPersonIds.includes(data.person_id) && (
                    <Box
                        width="90%"
                        flex={false}
                        direction="row"
                        alignSelf="center"
                        margin={{ horizontal: "10px", vertical: "5px" }}
                        elevation="large"
                        pad="10px"
                        round="5px"
                        background="rgba(255,255,255,0.9)"
                        align="start"
                        justify="between"
                    >
                        <Box
                            width="full"
                            direction="row"
                            align="center"
                            justify="start"
                        >
                            <IndexBox pindex={pindex} />
                            <YearBox year={data.data_year} />
                            <Box
                                direction="column"
                                margin={{ horizontal: "10px" }}
                            >
                                {/* book info */}
                                <Box
                                    direction="row"
                                    align="center"
                                    justify="start"
                                    margin={{ bottom: "5px" }}
                                >
                                    <BookInfo
                                        book_title={data.book_title}
                                        book_category={data.book_category}
                                        book_author={data.book_author}
                                        book_publisher={data.book_publisher}
                                        book_numeration={data.book_numeration}
                                        data_date={data.data_date}
                                    />
                                </Box>

                                {data.toc_title && (
                                    <TocInfo toc_title={toc_title} />
                                )}

                                {data.psnorder_text && (
                                    <Box
                                        direction="row"
                                        align="center"
                                        justify="start"
                                        margin={{ bottom: "5px" }}
                                    >
                                        <Text size="15px">
                                            <Text
                                                size="12px"
                                                margin={{ right: "10px" }}
                                            >
                                                내용:{" "}
                                            </Text>
                                            {data.psnorder_text && (
                                                <Text
                                                    size="15px"
                                                    margin={{ right: "15px" }}
                                                >
                                                    {data.psnorder_text
                                                        .split(",")
                                                        .map((p: any) => (
                                                            <PsnorderText
                                                                t={p} key={p}
                                                            />
                                                        ))}
                                                </Text>
                                            )}
                                        </Text>
                                    </Box>
                                )}
                                {data.toc_record_text && (
                                    <TocRecordInfo
                                        tocrecord_text={tocrecord_text_list}
                                    />
                                )}
                                {data.page_info && (
                                    <PageInfo page={data.page_info} />
                                )}
                                {data.related_school_id && (
                                    <Box
                                        direction="row"
                                        align="center"
                                        justify="start"
                                        margin={{ bottom: "5px" }}
                                    >
                                        <Text size="15px">
                                            <Text
                                                size="12px"
                                                margin={{ right: "12px" }}
                                            >
                                                관련학교:{" "}
                                            </Text>
                                            <Text
                                                size="12px"
                                                margin={{ right: "10px" }}
                                            >
                                                {data.related_school_name}
                                            </Text>
                                        </Text>
                                    </Box>
                                )}
                            </Box>
                        </Box>

                        {modificationMode && (
                            <Box
                                border
                                round="3px"
                                align="center"
                                justify="center"
                                height="full"
                                style={{ minWidth: "80px", maxWidth: "80px" }}
                            >
                                <ChangePersonSetting />
                            </Box>
                        )}
                    </Box>
                )}
            </>
        );
    };

    const [addMorePerson, setAddMorePerson] = React.useState<any>(false);

    const [modificationRecommand, setModificationRecommand] =
        React.useState<string>("");

    const RecommandTextBox = () => {
        let recommand_text = "KNUE_DATA_PERSON_MODIFICATION \n|";
        // add day and timestamp
        let today = new Date();
        let year = today.getFullYear();
        let month = today.getMonth() + 1;
        let date = today.getDate();
        let hour = today.getHours();
        let minute = today.getMinutes();
        let second = today.getSeconds();
        let milisecond = today.getMilliseconds();
        let timestamp =
            "yr" +
            year +
            ":mo" +
            month +
            ":dt" +
            date +
            ":hr" +
            hour +
            ":mn" +
            minute +
            ":sc" +
            second +
            ":ms" +
            milisecond;
        recommand_text += timestamp + " \n|";

        newShowDataList.forEach((d: any) => {
            if(selectedPersonIds.includes(d.person_id)){
                recommand_text += JSON.stringify(d) + " \n|";
            }
        });
        recommand_text += "END";
        return (
            <Box
                direction="column"
                style={{ minWidth: "500px", maxWidth: "500px" }}
                align="center"
                justify="center"
                pad="10px"
                height='full'
            >
                {/* <Box alignSelf="end">copy button</Box> */}
                <Box
                    alignSelf="center"
                    margin={{top:"50px"}}
                    height="500px"
                    pad="10px"
                    align="center"
                    round
                    border
                    style={{ minWidth: "500px", maxWidth: "500px" }}
                    flex={false}
                    overflow={{ vertical: "auto" }}
                >
                    <TextArea fill size="10px" value={recommand_text}
                    focusIndicator={false}
                    readOnly plain
                    >
                    </TextArea>
                </Box>
            </Box>
        );
    };

    return (
        <Box height="full">
            <PageMainCanvas>
                <Box
                    direction="row"
                    align="center"
                    width="full"
                    style={{ minHeight: "50px", maxHeight: "50px" }}
                >
                    <MdPerson size="30px" />
                    <Text size="20px">인물</Text>
                    <Box margin={{ left: "30px" }}>
                        <Button
                            focusIndicator={false}
                            plain
                            label={
                                <Box pad="10px">
                                    <Text size="15px">추가 검색</Text>
                                </Box>
                            }
                            icon={<Add size="15px" />}
                            onClick={() => setAddMorePerson(true)}
                            hoverIndicator
                        />
                    </Box>
                </Box>
                <PersonListBox />
                <Box
                    width="full"
                    direction="row"
                    style={{ minHeight: "20px", maxHeight: "20px" }}
                    align="center"
                    justify="end"
                    alignSelf="end"
                >
                    {modificationMode ? (
                        <>
                            <Button
                                plain
                                hoverIndicator={{ color: "yellow" }}
                                focusIndicator={false}
                                icon={<ShareRounded size="15px" color="red" />}
                                label={
                                    <Box
                                        align="center"
                                        justify="center"
                                        pad="2px"
                                    >
                                        <Text
                                            size="12px"
                                            color="red"
                                            weight="bold"
                                        >
                                            자료수정 제안하기
                                        </Text>
                                    </Box>
                                }
                                onClick={() => setSendModification(true)}
                            />
                            <Button plain focusIndicator={false} margin={{left:'10px'}}
                            hoverIndicator={{color:'yellow'}}
                            label={<Box align='center' justify='center' pad='2px'>
                                <Text size='12px'>자료수정 종료</Text>
                            </Box>}
                            icon={<Close size='13px' color='black'/>}
                            onClick={()=>setModificationMode(false)}
                            />
                        </>
                    ) : (
                        <Button
                            plain
                            hoverIndicator={{ color: "yellow" }}
                            icon={<StatusInfo size="15px" color="red" />}
                            label={
                                <Box align="center" justify="center" pad="2px">
                                    <Text size="12px" color="indigo">
                                        선택인물 자료수정
                                    </Text>
                                </Box>
                            }
                            onClick={() => startModification()}
                        />
                    )}
                </Box>
                <Box
                    width="full"
                    direction="row"
                    style={{ minHeight: "20px", maxHeight: "20px" }}
                    justify="between"
                    align="center"
                >
                    <Text size="10px">
                        전체 {personIds.length}명 / 자료 {showDataList.length}개
                    </Text>
                    <Text size="10px">
                        선택 {selectedPersonIds.length}명 / 자료{" "}
                        <Text size="10px">
                            {personIds.length === selectedPersonIds.length
                                ? showDataList.length
                                : filteredDataList.length}
                        </Text>
                        개
                    </Text>
                </Box>

                {readyShowList ? (
                    <Box
                        align="start"
                        justify="start"
                        overflow="auto"
                        width="full"
                        height="full"
                        border={{ side: "top", color: "black", size: "1px" }}
                        pad={{ top: "20px" }}
                    >
                        {showDataList.map((d: any) => (
                            <AData
                                data={d}
                                pindex={personInfos.findIndex(
                                    (p: any) =>
                                        p.person.person_id === d.person_id
                                )}
                                key={
                                    d.unit_id.toString() +
                                    d.person_id.toString()
                                }
                            />
                        ))}
                    </Box>
                ) : (
                    <LoadingSign />
                )}
            </PageMainCanvas>
            {addMorePerson && (
                <Box
                    direction="column"
                    background="rgba(255,255,255,0.5)"
                    alignSelf="center"
                    align="center"
                    justify="center"
                >
                    <Layer
                        onClickOutside={() => setAddMorePerson(false)}
                        onEsc={() => setAddMorePerson(false)}
                        modal
                        full
                    >
                        <Box
                            align="start"
                            justify="start"
                            alignSelf="center"
                            width="full"
                            height="full"
                        >
                            <Box
                                margin={{ top: "50px" }}
                                alignSelf="end"
                                hoverIndicator
                                focusIndicator={false}
                                onClick={() => setAddMorePerson(false)}
                                height="50px"
                            >
                                <Button
                                    size="15px"
                                    icon={<Close size="15px" />}
                                    onClick={() => setAddMorePerson(false)}
                                />
                            </Box>
                            <Box
                                width="90%"
                                height="80%"
                                align="center"
                                alignSelf="center"
                            >
                                <SearchPersonModal />
                            </Box>
                        </Box>
                    </Layer>
                </Box>
            )}
            {sendModification && (
                <Box
                    direction="column"
                    background="rgba(255,255,255,0.5)"
                    alignSelf="center"
                    align="center"
                    justify="center"
                >
                    <Layer
                        onClickOutside={() => setSendModification(false)}
                        onEsc={() => setSendModification(false)}
                        modal
                    >
                        <Box
                            align="start"
                            justify="start"
                            alignSelf="center"
                            width="full"
                            height="full"
                        >
                            <Box
                                margin={{ top: "50px" }}
                                alignSelf="end"
                                hoverIndicator
                                focusIndicator={false}
                                onClick={() => setAddMorePerson(false)}
                                height="50px"
                            >
                                <Button
                                    size="15px"
                                    icon={<Close size="15px" />}
                                    onClick={() => {
                                        setSendModification(false);
                                    }}
                                />
                            </Box>
                            <Box
                                width="90%"
                                height="80%"
                                align="center"
                                alignSelf="center"
                            >
                                <Text size="12px">아래 박스의 내용을 복사해서 관리자에게 보내주세요</Text>
                                {/* export newShowDataList by string */}
                                <Box
                                    width="full"
                                    height="full"
                                    overflow="auto"
                                    border={{
                                        side: "top",
                                        color: "black",
                                        size: "1px",
                                    }}
                                    pad={{ top: "20px" }}
                                    align="center"
                                    justify="start"
                                >
                                    <RecommandTextBox />
                                </Box>
                            </Box>
                        </Box>
                    </Layer>
                </Box>
            )}
        </Box>
    );
};

export default PagePersonMain;
